import { AxiosError } from "axios";
import { clearAuthStore } from "@/store/authStore";
import { redirectToLogin } from "@/store/authUtils.ts";

/** TanStack query-cache key names. */
export const QueryStoreEnum = {
    MediaFile: { name: "MediaFile" },
    Device: { name: "Device" },
    InterceptpGroup: { name: "InterceptpGroup" },
    UserGroup: { name: "UserGroup" },
    Extension: { name: "Extension" },
    Queue: { name: "Queue" },
    User: { name: "User" },
    CDR: { name: "Cdr" },
    SipTrunk: { name: "SipTrunk" },
    CallScript: { name: "CallScript" },
    ChatQueueTemplates: { name: "Chat.QueueTemplates" },
} as const;

export const DEFAULT_QUERY_STALE_TIME = 60 * 60 * 1000; // 1 hour
export const DEFAULT_QUERY_LIMIT = 10000;
export const DEFAULT_LABEL_QUERY_LIMIT = 1000;

/**
 * Client-wide retry default (CT-44 load hygiene): one retry, and never for a 4xx: a denied,
 * missing or unauthorized resource does not become available by asking again, and TanStack's
 * default of three exponential retries turned every cold-boot failure into a multi-second stall.
 * Queries with their own `retry` keep it.
 */
export function defaultQueryRetry(failureCount: number, error: unknown): boolean {
    const status = (error as { response?: { status?: number } } | undefined)?.response?.status;
    if (typeof status === "number" && status >= 400 && status < 500) return false;
    return failureCount < 1;
}

export function onQueryError(error: AxiosError, store: any) {
    if (error?.response?.status === 401) {
        store.addToast("expired");
    }

    if ([401, 500].includes(error?.response?.status || 0)) {
        clearAuthStore();
        redirectToLogin();
    }
}
